import React, { Component, useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import { PageContext } from "../PageContext";
import { PAGE } from "../constants";

import UserMgmt from "./UserManagement/UserMgmt";
import Profile from "./Profile/Profile";
import Designer from "./Designer";
import ProcessDiscovery from "./ProcessDiscovery";

import { AgentManagement } from "./AgentManagement/AgentManagent";
import { invalidateSession, isUserLoggedIn } from "../apis/sessionUtil";
import Monitor from "./Monitor";
import Avatar from "@material-ui/core/Avatar";
import Analytics from "./Analytics";
import PortalConfig from "./PortalConfig";


import "../app.css";

import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SearchIcon from "@material-ui/icons/YoutubeSearchedFor";
// import SearchIcon from '@mui/icons-material/ManageSearch';
import DesignerIcon from "@material-ui/icons/Stars";
import UserIcon from "@material-ui/icons/AccountCircleRounded";
import AgentIcon from "@material-ui/icons/Settings";
import UserMgmtIcon from "@material-ui/icons/GroupRounded";
import BotIcon from "@material-ui/icons/Explore";
import { Auth } from "aws-amplify";
import AnalyticsIcon from "@material-ui/icons/Assessment";
import MonitoringIcon from "@material-ui/icons/Visibility";
import PortalIcon from "@material-ui/icons/Public";
import Grid from "@material-ui/core/Grid";

import LifeCycle from "./LifeCycle";
import { BotsLifeCycle } from "./botsdeployer/BotsLifeCycle";
import { IconButton } from "@material-ui/core";
import { LightTooltip } from "./LightTooltip";
import { getLoggedInUserName } from "../apis/sessionUtil";
import { Position } from "react-flow-renderer";
import "./GenericReusableComponents/table.css";
import useStyles from "./muistyles";

export function Home() {
  const [value, setValue] = useState(1);
  const [render, setRender] = useState(false);
  const [show, setShow] = useState(false);
  const { page, setPage } = useContext(PageContext);
  const classes = useStyles();

  if (!isUserLoggedIn()) {
    console.log("Home: User is not logged in so redirecting to the home page");
    setPage(PAGE.LOGIN);
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tab = () => {
    switch (value) {
      case 0:
        return <ProcessDiscovery />;
      case 1:
        return <Designer />;

      case 2:
        return <AgentManagement />;

      case 3:
        return <UserMgmt />;
  
      case 4:
        return <BotsLifeCycle />;
  
      case 5:
        return <Monitor />;

  
      case 6:
        return <Analytics />;


      // // case 5:
      // //     return <Profile />;

        
      // case 7:
      //   return <PortalConfig />;

          default:
        return <Designer />;
    }
  };

  function logout(event) {
    event.preventDefault();
    invalidateSession();
    Auth.signOut()
      .then((result) => console.log(result))
      .catch((err) => console.error(err));

    setRender(true); //this is to trigger a render
    console.log("Inside logout");
  }

  /*function displayLogout() {
      console.log("Is displayLogout");
      if (isLoggedIn) {
        console.log("User is logged in so display logout");
        return <span className="logout"><a href="#" onClick={logout}>Logout</a></span>;
      } else {
        return "";
      }
    }*/

  function handleProfileClick() {
    setShow(true);
  }

  const style = { color: "white", fontSize: "32",                   
};
  // const style={color:'white', fontSize: '32', "&:hover": {
  //     color: "blue"
  //   },
  //     "&:indicator":{
  //         color:'white',

  // }
  // }

  return (
    <div>

  
          {/* <Paper square className={classes.papertabs}> */}



          <div className='leftTabBar' >
            <Tabs
              // orientation="vertical"
              // value={value}

              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              label="App Menu"
              orientation="vertical"
              className={classes.tabs}
              backgroundColor="white"              

              TabIndicatorProps={{
                style: {
                  backgroundColor: "white",
                },
              }}
            >
              <LightTooltip title="Process Discovery">
                <Tab className="pdtab" icon={<SearchIcon className='tabButton' />} />
              </LightTooltip>

              <LightTooltip title="Bot Designer">
                <Tab className="pdtab" icon={<DesignerIcon className='tabButton' />} />
              </LightTooltip>


              <LightTooltip title="Environment Setup">
                <Tab className="pdtab" icon={<AgentIcon className='tabButton' />} />
              </LightTooltip>

              <LightTooltip title="User Management">
                <Tab className="pdtab" icon={<UserMgmtIcon className='tabButton' />} />
              </LightTooltip>


              <LightTooltip title="Bot Explorer">
                <Tab className="pdtab" icon={<BotIcon className='tabButton' />} />
              </LightTooltip>

              <LightTooltip title="Monitoring">
                <Tab className="pdtab" icon={<MonitoringIcon className='tabButton' />} />
              </LightTooltip>



              <LightTooltip title="Analytics">
                <Tab className="pdtab" icon={<AnalyticsIcon className='tabButton' />} />
              </LightTooltip>



              {/* <LightTooltip title="User Management">
                <Tab className="pdtab" icon={<UserMgmtIcon className='tabButton' />} />
              </LightTooltip>

              <LightTooltip title="Analytics">
                <Tab className="pdtab" icon={<AnalyticsIcon className='tabButton' />} />
              </LightTooltip>

              <LightTooltip title="Portal">
                <Tab className="pdtab" icon={<PortalIcon className='tabButton' />} />
              </LightTooltip> */}
            </Tabs>
          </div>

          {/* <Paper className={classes.paper}>{tab()}</Paper> */}
          <div style={{height:'100vh'}}>{tab()}</div>
         
     
    </div>
  );
}
